import styled, { css } from 'styled-components';

import { ColorName } from 'types';

import { getHoverColor, pickColor } from 'themes/helpers/pickColor';

import { Button } from 'components/Button';
import { Headline } from 'components/Headline';

const Container = styled.div`
  padding: 1.5rem;
`;

const Title = styled(Headline)<{ barColor: ColorName }>`
  padding: 1.5rem 1.5rem 0;
  color: ${({ barColor }) => barColor && pickColor(barColor)};
`;

const Description = styled.p`
  padding: 0 1.5rem;
  margin: 0;
  font-size: 1.4rem;
  color: ${pickColor('black')};
  line-height: 1.4;
`;

const Actions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  margin-top: 2rem;
`;

/** Cancel in the catalogue colour too: white with a coloured border and text. */
const Cancel = styled(Button)<{ $color?: ColorName }>`
  ${({ $color }) =>
    $color &&
    css`
      background-color: ${pickColor('white')};
      border: 0.1rem solid ${pickColor($color)};
      color: ${pickColor($color)};

      &:hover {
        background-color: ${pickColor($color)};
        color: ${pickColor('white')};
      }
    `};
`;

const Submit = styled(Button)<{ barColor: ColorName }>`
  background-color: ${({ barColor }) => barColor && pickColor(barColor)};
  &:hover {
    background-color: ${({ barColor }) => barColor && pickColor(getHoverColor(barColor))};
  }
`;

export { Actions, Cancel, Container, Description, Submit, Title };
